
import { defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheTextarea from '@/common/components/UI/TheTextarea/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        modal: Modal,
        'the-textarea': TheTextarea,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['cancel', 'submitted'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            lack_data_comment: null as string | null,
        })

        const state_form$ = useVuelidate({ lack_data_comment: { required } }, state)

        const emitCancel = () => {
            emit('cancel')
        }

        const emitSubmitted = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submitted', state.lack_data_comment)
        }

        return {
            state,
            state_form$,
            emitCancel,
            emitSubmitted,
        }
    },
})
